import { FetchGet, PagingDataResponse, useFetchGet } from '../fetch';
import { Ticket } from '../../store/ticket';
import { TicketListGetParams } from '../../store/ticket/list';

export const useTicketsGet = (): FetchGet<
  PagingDataResponse<Ticket>,
  Partial<TicketListGetParams>
> => useFetchGet(
  'admin/tickets',
  {
    autoStart: false,
    startStateLoading: false,
  },
);

export default {
  useTicketsGet,
};
